import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { useEquipment } from '../hooks/useEquipment';

// Set context type based on the return of your useEquipment hook
type UseEquipmentReturn = ReturnType<typeof useEquipment>;

// Creates an Equipment Contex
const EquipmentContext = createContext<UseEquipmentReturn | undefined>(
  undefined
);

// return received values to current context
export const EquipmentProvider = ({
  values,
  children,
}: {
  values: UseEquipmentReturn;
  children: ReactNode;
}) => {
  return (
    <EquipmentContext.Provider value={values}>
      {children}
    </EquipmentContext.Provider>
  );
};

export const useEquipmentContext = () => {
  const ctx = useContext(EquipmentContext);
  if (!ctx)
    throw new Error('useEquipmentContext must be inside EquipmentProvider');
  return ctx;
};
